/* eslint-disable */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';
import css from './Arrow.scss';

const classes = {
	root: css.arrow,
	isDisable: css.isDisable,
};

const propTypes = {
	className: PropTypes.string,
	classes: PropTypes.objectOf(PropTypes.string),
	disabled: PropTypes.bool,
};

const defaultProps = {
	className: '',
	classes,
	disabled: false,
};

export const Arrow = forwardRef(({
	className,
	classes,
	disabled,
	...props
}, ref) =>  {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 26.484 32.453'
			className={cls(classes.root, className, {
				[classes.isDisabled]: disabled,
			})}
			{...props}
			ref={ref}>
			<g transform='rotate(90 514.922 491.922)'>
				<path
					d='M54.973 992.344l-10.818-11.419a2.009 2.009 0 00-2.644-.12 1.886 1.886 0 000 2.644l7.933 8.354H24.8a1.8 1.8 0 000 3.606h24.644l-7.933 8.354a1.833 1.833 0 000 2.644 2.013 2.013 0 002.644-.12l10.818-11.419a1.909 1.909 0 000-2.524z'
				/>
			</g>
		</svg>
	);
});

Arrow.displayName = 'Arrow';
Arrow.propTypes = propTypes;
Arrow.defaultProps = defaultProps;
export default Arrow;
